import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=4b97034a"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=4b97034a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b97034a')) {
      api.createRecord('4b97034a', component.options)
    } else {
      api.reload('4b97034a', component.options)
    }
    module.hot.accept("./Privacy.vue?vue&type=template&id=4b97034a", function () {
      api.rerender('4b97034a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/Privacy.vue"
export default component.exports